import React, { useState } from "react";
import { Typography } from "antd";
import { LuFileText, LuImage, LuVideo } from "react-icons/lu";
import { MEDIA_TYPE, getMediaTypeLabel } from "../activityCenter/mediaTrackingHelpers";

const { Text } = Typography;

const MEDIA_ICON_MAP = {
  [MEDIA_TYPE.IMAGE]: LuImage,
  [MEDIA_TYPE.VIDEO]: LuVideo,
  [MEDIA_TYPE.DOC]: LuFileText,
};

const Thumbnail = ({ src }) => {
  const [loaded, setLoaded] = useState(false);
  return (
    <span className="relative inline-block w-8 h-8 rounded overflow-hidden flex-shrink-0">
      {!loaded && <span className="absolute inset-0 bg-gray-100 animate-pulse" />}
      {/* eslint-disable-next-line jsx-a11y/alt-text */}
      <img
        src={src}
        width={32}
        height={32}
        decoding="async"
        fetchPriority="low"
        alt=""
        onLoad={() => setLoaded(true)}
        onError={() => setLoaded(true)}
        className="absolute inset-0 w-full h-full object-cover"
      />
    </span>
  );
};

const MediaLabel = ({ type, thumbnail, count, label }) => {
  const IconComponent = MEDIA_ICON_MAP[type];

  return (
    <span className="flex items-center gap-2">
      {thumbnail ? (
        <Thumbnail src={thumbnail} />
      ) : (
        IconComponent && (
          <div className="flex items-center justify-center w-8 h-8 rounded bg-gray-50 text-gray-400 flex-shrink-0">
            <IconComponent size={18} />
          </div>
        )
      )}
      <Text className="!text-sm whitespace-nowrap">{label || getMediaTypeLabel(type, count)}</Text>
    </span>
  );
};

export default React.memo(MediaLabel);
